(function GroupIndex($, Adzuki)
{
	"use strict";

	Adzuki.onload(
		['GroupRegistrations/registrants/'],
		init,
		false
	);

	function init()
	{
		$('.view-passenger-manifest').on('click', viewPassengerManifest);
	}

	function viewPassengerManifest(e)
	{
		var registration_id = $(this).data("registration-id"),
			$modal   = $(".modal"),
			url      = '/GroupRegistrations/viewManifest/' + registration_id;

		e.preventDefault();

		$modal.addClass('wide');
		$modal.find('.modal-body').text('Loading Passenger Manifest...');

		Adzuki.Ajax.get(url)
		.then(function success(html) {
			$modal.find('.modal-body').html(html);
			$modal.find('[data-toggle^="tooltip"]').tooltip();
		});

		$modal.find('.modal-title').text('Passenger Manifest');
		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal');
		}).modal('show');
	}
}(jQuery, window.Adzuki || {}));